var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.env == 'development' ? 'phm' : 'phm hide',attrs:{"id":"vue-mobile-menu"}},[_c('Menu',{attrs:{"items":_vm.menuItems}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }